import React from 'react';
import { Icon } from './Icon.js';
export const IconCheckboxChecked = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("rect", { x: "3", y: "3", width: "14", height: "14", rx: "3", ry: "3", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" }),
        React.createElement("polyline", { points: "6.5 10.5 8.75 13 13.5 7", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", "data-color": "color-2" })));
};
//# sourceMappingURL=IconCheckboxChecked.js.map